import React from 'react';
import CustomerListFilters from '../components/CustomerListFilters';
import CustomerListPageActions from '../components/CustomerListPageActions';
import useDocumentTitle from '../../../hooks/useDocumentTitle';
import CustomersTable from '../components/CustomersTable';
import { Box, Stack } from '@mui/material';
import TopBar from '../../../components/TopBar';
import useCustomerFilters from '../components/CustomerFilterHelper';
import { useTranslatedMessages } from '../../../hooks/useTranslatedMessages';

const filters = [
  {
    type: 'search',
    options: [
      {
        key: 'name',
        placeholder: 'Customer Name',
      },
      {
        key: 'company_id',
        placeholder: 'VAT Number',
      },
      {
        key: 'email',
        placeholder: 'Email',
      },
    ],
  },
];

function CustomerListPage() {
  const { customers: c } = useTranslatedMessages();
  const page = c?.pages?.list ?? {};
  const placeholders = page?.filters?.placeholders ?? {};
  useDocumentTitle(page?.document_title ?? 'Customer List');

  const {
    selectedFilter,
    searchTerm,
    currentQuery,
    customerType,
    handleFilterChange,
    handleSearchChange,
    handleSearchKeyPress,
    handleCustomerTypeChange,
    handlePaginationChange,
  } = useCustomerFilters({ defaultQuery: {}, searchOnChange: true, persistKey: 'customers' });

  const translatedFilters = [
    {
      type: 'search',
      options: [
        { key: 'name', placeholder: placeholders.name ?? 'Customer Name' },
        { key: 'company_id', placeholder: placeholders.vat_number ?? 'VAT Number' },
        { key: 'email', placeholder: placeholders.email ?? 'Email' },
      ],
    },
  ];

  return (
    <Stack direction="column" sx={{ mt: '-1rem' }}>
      <TopBar title={page?.top_bar_title ?? 'Customers'}>{<CustomerListPageActions />}</TopBar>
      <Box mb={2}>
        <CustomerListFilters
          filters={translatedFilters}
          selectedFilter={selectedFilter}
          onFilterChange={handleFilterChange}
          searchTerm={searchTerm}
          onSearchChange={handleSearchChange}
          onSearchKeyPress={handleSearchKeyPress}
          customerType={customerType}
          onCustomerTypeChange={handleCustomerTypeChange}
        />
      </Box>
      <CustomersTable handlePaginationChange={handlePaginationChange} searchQuery={currentQuery} />
    </Stack>
  );
}

export default CustomerListPage;
